import { jsx } from "react/jsx-runtime";
import { useConfig } from "../../../../contexts/config-context.js";
import { FormViewContext } from "../../../../contexts/form-view-context.js";
import { UniqueFieldSuffixContextProvider } from "../../../../contexts/unique-field-suffix-context.js";
import { Grid } from "../grid/grid.js";
import { createFormFields } from "./create-form-fields.js";
import { DefaultFieldLayout } from "../../../../field-layout/default-field-layout.js";
const FormRoot = ({
  form,
  values,
  onFieldChange,
  onBlur,
  onFocus,
  errors,
  formSchema,
  validateFields,
  fields,
  fieldActions
}) => {
  const { isRTL } = useConfig();
  const formFields = createFormFields({
    form,
    values,
    onFieldChange,
    onBlur,
    onFocus,
    errors,
    FieldLayout: DefaultFieldLayout,
    formSchema,
    validateFields,
    fields,
    fieldActions
  });
  return /* @__PURE__ */ jsx(Grid, { isRTL, items: formFields, layout: form.grid });
};
const Form = (props) => {
  return /* @__PURE__ */ jsx(FormViewContext.Provider, { value: props.form, children: /* @__PURE__ */ jsx(UniqueFieldSuffixContextProvider, { parentId: props.form.parentId, children: /* @__PURE__ */ jsx(FormRoot, { ...props }) }) });
};
export {
  Form
};
//# sourceMappingURL=form.js.map
